import StatusToken from '@admin/tokens/status'
import Panel from '@admin/components/panel'
import TeamToken from '@admin/tokens/team'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Referrals)',
  collection: {
    endpoint: `/api/admin/truevail/admin/affiliates/${props.affiliate.id}/referrals`,
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Team)', key: 'title', primary: true, format: TeamToken },
      { label: 't(Next Payout)', key: 'next_payout_date', collapsing: true, align: 'right', format: 'date' },
      { label: 't(Commission)', key: 'commission', collapsing: true, align: 'right', format: 'currency' },
      { label: 't(Status)', key: 'status', sort: 'status', collapsing: true, format: StatusToken }
    ],
    empty: {
      title: 't(No Referrals)',
      text: 't(There are no referrals for this affiliate)',
      svg: 'heart_handshake'
    },
    entity: 'team',
    defaultSort: { key: 'created_at', order: 'desc' },
    onClick: (record) => context.router.push(`/admin/truevail/admin/advisors/${record.advisor.id}`)
  }
})

export default Panel(null, mapPropsToPanel)
